export default "__VITE_ASSET__B1WDF8Ex__"